export default __webpack_public_path__ + "static/media/aUST.36049b56.png";